document.addEventListener('DOMContentLoaded', () => {
  runCartClearOnce();
});

function initializeMinicartSwiper() {
  if (
    document.querySelectorAll(
      "#main-minicart .product-recommendations .swiper-slide"
    ).length > 2
  ) {
    new Swiper(".product-recommendations .swiper", {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 14,
      navigation: {
        nextEl: ".swipper-custom-minicart-buttons .swiper-button-next-minicart",
        prevEl: ".swipper-custom-minicart-buttons .swiper-button-prev-minicart",
      },
    });
  } else {
    document
      .querySelector(".cart-items .swipper-custom-minicart-buttons")
      .classList.add("no-slider");
    document
      .querySelector("#minicart-recomendation ul")
      .classList.remove("swiper-wrapper");
    document.querySelectorAll("#minicart-recomendation ul li").forEach((el) => {
      el.classList.remove("swiper-slide");
      el.classList.add("column-item");
    });
    document
      .querySelector("#minicart-recomendation ul")
      .classList.add("item-columns");
  }
}

const updateMinicartItems = async (id, quantity) => {
  const updateCartUrl = "/cart/update.js";

  const updates = {
    [id]: parseInt(quantity),
  };

  try {
    const response = await fetch(updateCartUrl, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ updates }),
    });

    if (response.ok) {
      await manageBonusItem();
      await manageLinkedProducts();
      await manageGlobalGift();
      updateMiniCartInFront();
    }
  } catch (error) {
    console.error(error);
  }
};

const addToCart = async (id, qtd = 1) => {
  const productId = parseInt(id);
  const quantity = parseInt(qtd);

  const urlAddToCart = "/cart/add.js";

  const productObj = {
    items: [
      {
        id: productId,
        quantity: quantity,
      },
    ],
  };

  try {
    const response = await fetch(urlAddToCart, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(productObj),
    });

    if (response.ok) {
      await manageBonusItem();
      await manageLinkedProducts();
      await manageGlobalGift();
      updateMiniCartInFront();
      document.querySelector(".overlay-bg").classList.add("active");
      document.querySelector("#main-minicart").classList.add("active");
    }
  } catch (error) {
    console.error(error);
  }
};

const removeItemFromCart = async (id, qtd = 0) => {
  const removeItemFromCartUrl = "/cart/change.js";
  const productDelete = {
    id: id,
    quantity: qtd,
  };
  try {
    const response = await fetch(removeItemFromCartUrl, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(productDelete),
    });

    if (response.ok) {
      await manageBonusItem();
      await manageLinkedProducts();
      await manageGlobalGift();
      // await manageGiftBonus();
      updateMiniCartInFront();
    }
  } catch (error) {
    console.error(error);
  }
};

const productRecomendationMinicart = async (url) => {
  try {
    const response = await fetch(url, {
      method: "GET",
    });

    if (response.ok) {
      response.text().then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;

        const productRecommendationsSection = document.querySelector(
          "#main-minicart .product-recommendations"
        );
        const recommendations = html.querySelector(
          "#main-minicart .product-recommendations"
        );

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        initializeMinicartSwiper();
      });
    }
  } catch (error) {
    console.error(error);
  }
};

const updateMiniCartInFront = async () => {
  const getCartUrl = "/?section_id=main-minicart";

  try {
    const response = await fetch(getCartUrl, {
      method: "GET",
    });

    if (response.ok) {
      response.text().then((res) => {
        const divHtml = document.createElement("div");
        divHtml.innerHTML = res;

        const box_items = divHtml.querySelector("#main-minicart").innerHTML;
        document.querySelector("#main-minicart").innerHTML = box_items;

        let items_count = divHtml.querySelector(
          ".minicart-items-count"
        ).innerText;
        items_count = items_count.replace(/\s+/g, '').trim();
        document.querySelectorAll(
          "#toggle-minicart .minicart-items-count"
        ).forEach(el => el.innerText = items_count)

        const urlRecomendationMinicart = divHtml.querySelector(
          "#main-minicart .product-recommendations"
        ).dataset.url;
        productRecomendationMinicart(urlRecomendationMinicart);
      });
    }
  } catch (error) {
    console.error(error);
  }
};



const closeMinicart = () => {
  document.querySelector("#main-minicart").classList.remove("active");
  document.querySelector(".overlay-bg").classList.remove("active");
};
const openMinicart = () => {
  document.querySelector("#main-minicart").classList.add("active");
  document.querySelector(".overlay-bg").classList.add("active");
};

const stepUpInput = (element, id, qtd) => {
  const quantity = parseInt(qtd) + 1;
  const input = element.previousElementSibling;
  input.stepUp();

  updateMinicartItems(id, quantity);
};
const stepDownInput = (element, id, qtd) => {
  const quantity = parseInt(qtd) - 1;
  const input = element.nextElementSibling;
  input.stepDown();

  if (!quantity <= 0) updateMinicartItems(id, quantity);
};

async function calculateShipping() {
  const cep = document.querySelector("#cep-calc").value;
  const reqProvince = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
  const resProvince = await reqProvince.json();

  if (resProvince.erro) {
    alert("CEP inválido");
    return;
  }

  const clientCep = cep;
  const country = "Brazil";
  const province = resProvince.estado;

  var shippingData = {
    zip: clientCep,
    country: country,
    province: province,
  };

  createShippingRates(shippingData);
}

async function createShippingRates(shippingData) {
  const url_prepare = `/cart/prepare_shipping_rates.json`;

  const requestData = {
    "shipping_address[zip]": shippingData.zip,
    "shipping_address[country]": shippingData.country,
    "shipping_address[province]": shippingData.province,
  };

  const request = await fetch(url_prepare, {
    method: "POST",
    body: requestData,
  });
  const response = await request.json();

  if (response.ok) {
    getShippingRates(shippingData);
  } else {
    console.error("Erro na solicitação:", response.error);
  }
}

async function getShippingRates(shippingData) {
  if (shippingData) {
    const url_async = `/cart/shipping_rates.json?shipping_address%5Bzip%5D=${shippingData.zip}&shipping_address%5Bcountry%5D=Brazil&shipping_address%5Bprovince%5D=${shippingData.province}`;

    const request = await fetch(url_async, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const response = await request.json();

    if (response.ok) {
      if (response.shipping_rates) {
        createShippingTable(response.shipping_rates);
      }
    } else {
      console.error(response.error);
    }
  }
}

function calculateShipping() {
  let cep = document.querySelector("#cep-calc").value.replace("-", "");
  fetch(`https://viacep.com.br/ws/${cep}/json/`)
    .then((response) => response.json())
    .then((resProvince) => {
      if (resProvince.erro) {
        alert("CEP inválido");
        return;
      }

      const estados = {
        AC: "Acre",
        AL: "Alagoas",
        AP: "Amapá",
        AM: "Amazonas",
        BA: "Bahia",
        CE: "Ceará",
        DF: "Distrito Federal",
        ES: "Espírito Santo",
        GO: "Goiás",
        MA: "Maranhão",
        MT: "Mato Grosso",
        MS: "Mato Grosso do Sul",
        MG: "Minas Gerais",
        PA: "Pará",
        PB: "Paraíba",
        PR: "Paraná",
        PE: "Pernambuco",
        PI: "Piauí",
        RJ: "Rio de Janeiro",
        RN: "Rio Grande do Norte",
        RS: "Rio Grande do Sul",
        RO: "Rondônia",
        RR: "Roraima",
        SC: "Santa Catarina",
        SP: "São Paulo",
        SE: "Sergipe",
        TO: "Tocantins",
      };

      const shippingData = {
        zip: cep,
        country: "Brazil",
        province: estados[resProvince.uf],
      };

      createShippingRates(shippingData);
    })
    .catch((error) => console.error(error));
}

function createShippingRates(shippingData) {
  const urlPrepare = "/cart/prepare_shipping_rates.json";
  const requestData = new URLSearchParams({
    "shipping_address[zip]": shippingData.zip,
    "shipping_address[country]": shippingData.country,
    "shipping_address[province]": shippingData.province,
  });

  fetch(urlPrepare, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: requestData,
  })
    .then((response) => {
      if (response.ok) {
        getShippingRates(shippingData);
      } else {
        console.error(response.statusText);
      }
    })
    .catch((error) => console.error(error));
}

function getShippingRates(shippingData) {
  const urlAsync = `/cart/shipping_rates.json?shipping_address[zip]=${shippingData.zip}&shipping_address[country]=Brazil&shipping_address[province]=${shippingData.province}`;

  fetch(urlAsync)
    .then((response) => response.json())
    .then((result) => {
      console.log(result);

      if (result.shipping_rates) {
        createShippingTable(result.shipping_rates);
      }
    })
    .catch((error) => console.error(error));
}

async function createShippingTable(shippingRates) {
  const shippingArea = document.getElementById("shipping-area");
  shippingArea.innerHTML = "";

  const cartData = await fetch("/cart.js", {
    headers: {
      Accept: "application/json",
    },
  }).then((response) => response.json());
  const cartTotal = cartData.total_price / 100;

  if (shippingRates && shippingRates.length > 0) {
    const element = document.createElement("div");
    element.className = "shipping-table";

    shippingRates.forEach((rate) => {
      const cell = document.createElement("div");
      cell.className = "shipping-line py-2 border-b";
      const shippingPriceText =
        cartTotal >= 499 ? "Grátis" : `R$ ${rate.price.replace(".", ",")}`;
      cell.innerHTML = `
        <div class="flex flex-wrap gap-4 justify-between">
          <p class="text-xs">${rate.name} - ${rate.description}</p>
          <p class="text-xs">${shippingPriceText}</p>
        </div>
      `;
      element.appendChild(cell);
    });

    shippingArea.appendChild(element);
  } else {
    const noShippingMessage = document.createElement("p");
    noShippingMessage.className = "no-shipping-message";
    noShippingMessage.textContent =
      "Nenhuma opção de frete disponível para o CEP informado.";
    shippingArea.appendChild(noShippingMessage);
  }
}

document.addEventListener("DOMContentLoaded", function (event) {
  const cepInput = document.getElementById("cep-calc");

  cepInput?.addEventListener("input", function () {
    let cep = cepInput.value.replace(/\D/g, "");
    if (cep.length > 5) {
      cep = cep.slice(0, 5) + "-" + cep.slice(5, 8);
    }
    cepInput.value = cep;
  });
});

document.addEventListener("DOMContentLoaded", function (event) {
  let clearBtn = document.querySelector("#clear-discount-btn");
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector(
    "#applied-discount-code .applied-discount-code-wrapper"
  );
  let discountCodeValue = document.querySelector(
    "#applied-discount-code .applied-discount-code-value"
  );
  let discountCodeInput = document.querySelector("#discount-code-input");
  let totalCartSelector = document.querySelector(".cart__subtotal .money");
  let authorization_token;

  let checkoutContainer = document.createElement("div");
  document.body.appendChild(checkoutContainer);
  if (localStorage.discountCode)
    applyDiscount(JSON.parse(localStorage.discountCode).code);
  if (applyBtn)
    applyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      applyDiscount(discountCodeInput.value);
    });
  if (clearBtn)
    clearBtn.addEventListener("click", function (e) {
      e.preventDefault();
      clearDiscount();
    });

  function clearDiscount() {
    discountCodeValue.innerHTML = "";
    discountCodeError.innerHTML = "";
    clearLocalStorage();
    fetch("/discount/CLEAR");
  }

  function clearLocalStorage() {
    if (discountCodeWrapper) discountCodeWrapper.style.display = "none";
    if (totalCartSelector)
      totalCartSelector.innerHTML = JSON.parse(
        localStorage.discountCode
      ).totalCart;
    localStorage.removeItem("discountCode");
  }

  function applyDiscount(code) {
    if (applyBtn) {
      applyBtn.innerHTML =
        "<span class='flex items-center gap-2 justify-center'>Aplicando <div class='loader animate-spinFast border-5 border-gray-200 border-t-4 border-t-black rounded-full w-[15px] h-[15px] animate-spin'></div></span>";
      applyBtn.style.pointerEvents = "none";
    }
    fetch("/payments/config", { method: "GET" })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        const checkout_json_url = "/wallets/checkouts/";
        authorization_token = btoa(data.paymentInstruments.accessToken);
        fetch("/cart.js", {})
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            let body = {
              checkout: {
                country: Shopify.country,
                discount_code: code,
                line_items: data.items,
                presentment_currency: Shopify.currency.active,
              },
            };
            fetch(checkout_json_url, {
              headers: {
                accept: "*/*",
                "cache-control": "no-cache",
                authorization: "Basic " + authorization_token,
                "content-type": "application/json, text/javascript",
                pragma: "no-cache",
                "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors",
                "sec-fetch-site": "same-origin",
              },
              referrerPolicy: "strict-origin-when-cross-origin",
              method: "POST",
              mode: "cors",
              credentials: "include",
              body: JSON.stringify(body),
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (data) {
                console.log(data.checkout);
                if (
                  data.checkout &&
                  data.checkout.applied_discounts.length > 0
                ) {
                  let discountApplyUrl =
                    "/discount/" +
                    code +
                    "?v=" +
                    Date.now() +
                    "&redirect=/checkout/";
                  fetch(discountApplyUrl, {}).then(function (response) {
                    return response.text();
                  });
                  if (discountCodeWrapper)
                    discountCodeWrapper.style.display = "inline";
                  if (discountCodeError) discountCodeError.innerHTML = "";
                  if (discountCodeValue)
                    discountCodeValue.innerHTML =
                      data.checkout.applied_discounts[0].title +
                      " (" +
                      "R$" +
                      data.checkout.applied_discounts[0].amount +
                      ")";
                  let localStorageValue = {
                    code: code.trim(),
                    totalCart: data.checkout.total_line_items_price,
                  };
                  localStorage.setItem(
                    "discountCode",
                    JSON.stringify(localStorageValue)
                  );
                  if (totalCartSelector)
                    totalCartSelector.innerHTML =
                      "<s>" +
                      data.checkout.total_line_items_price +
                      "</s>" +
                      data.checkout.total_price;
                } else {
                  if (discountCodeValue) discountCodeValue.innerHTML = "";
                  clearLocalStorage();
                  if (discountCodeError)
                    discountCodeError.innerHTML = "Insira um cupom valido.";
                }
              })
              .finally(function (params) {
                if (applyBtn) {
                  applyBtn.innerHTML = "Aplicar";
                  applyBtn.style.pointerEvents = "all";
                }
              });
          });
      });
  }
});

async function manageBonusItem() {
  const IS_CUMULATIVE = true;
 const DISCOUNT_PERCENT = 0.30; 

  if (document.querySelector(".cart-drawer-items")) {
    const bonusItemVariantId = Number(
      document
        .querySelector(".cart-drawer-items")
        .getAttribute("bonusitemvariantid")
    );
    const minCartValue = Number(
      document.querySelector(".cart-drawer-items").getAttribute("mincartvalue")
    );
    const bonusItemPrice = Number(
      document
        .querySelector(".cart-drawer-items")
        .getAttribute("bonusitemprice")
    );
    const productsInStock = Number(
      document.querySelector(".cart-drawer-items").getAttribute("giftStock")
    );
    const giftActive =
      document
        .querySelector(".cart-drawer-items")
        .getAttribute("giftActive") === "true";

    const start_date = parseDate(
      document.querySelector(".cart-drawer-items").getAttribute("start_date")
    );
    const end_date = parseDate(
      document.querySelector(".cart-drawer-items").getAttribute("end_date")
    );

    if (productsInStock == 0 || giftActive == false) return -1;
    if (new Date() < start_date || new Date() > end_date) return -1;

    try {
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      let bonusItemKey = null;
      let currentBonusQuantity = 0;

      cart.items.forEach((item) => {
        if (item.variant_id === bonusItemVariantId) {
          bonusItemKey = item.key;
          currentBonusQuantity = item.quantity;
        }
      });

      const cartValueWithoutBonus = bonusItemKey
        ? cart.total_price - bonusItemPrice * currentBonusQuantity
        : cart.total_price;

        const discountedCartValue = cartValueWithoutBonus * (1 - DISCOUNT_PERCENT);

        const eligibleBonusQuantity = IS_CUMULATIVE
          ? Math.floor(discountedCartValue / minCartValue)
          : discountedCartValue >= minCartValue ? 1 : 0;


  

      if (eligibleBonusQuantity > 0) {
        if (currentBonusQuantity !== eligibleBonusQuantity) {
          if (bonusItemKey) {
            // Atualiza a quantidade se o brinde já está no carrinho
            await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: bonusItemKey,
                quantity: eligibleBonusQuantity,
              }),
            });
          } else {
            // Adiciona o brinde pela primeira vez
            await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                items: [
                  {
                    id: bonusItemVariantId,
                    quantity: eligibleBonusQuantity,
                    properties: { gift: true },
                  },
                ],
              }),
            });
          }
        }
      } else if (currentBonusQuantity > 0) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: bonusItemKey,
            quantity: 0,
          }),
        });
      }
    } catch (error) {
      console.error("Erro ao gerenciar brinde:", error);
    }
  }
}


const linkedGroups = [
  {
    mains: [
      { id: 49952073351487, factor: 2 }, 
      { id: 49952073122111, factor: 1 }, 
    ],
    bonus: 51241734340927
  },
  {
    mains: [
      { id: 50003382731071, factor: 2 }, 
      { id: 50003382698303, factor: 1 }
    ],
    bonus: 51292515434815
  },
    {
    mains: [
      { id: 50087558250815, factor: 2 }, 
      { id: 50087558054207, factor: 1 }
    ],
    bonus: 51310040056127
  },
    {
    mains: [
      { id: 49952078987583, factor: 2 }, 
      { id: 49952078790975, factor: 1 }
    ],
    bonus: 51310040449343
  },
    {
    mains: [
      { id: 49952063979839, factor: 2 }, 
      { id: 49952063947071, factor: 1 }
    ],
    bonus: 51310041170239
  },
    {
    mains: [
      { id: 49952077250879, factor: 2 }, 
      { id: 49952077185343, factor: 1 }
    ],
    bonus: 51310041727295
  },
      {
    mains: [
      { id: 49952062308671, factor: 2 }, 
      { id: 49952062079295, factor: 1 }
    ],
    bonus: 51310042186047
  }
];

async function manageLinkedProducts() {
  if (window._linkedBonusUpdating) return;
  window._linkedBonusUpdating = true;

  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    const findItem = (id) =>
      cart.items.find(i => Number(i.variant_id) === Number(id));

    for (const group of linkedGroups) {
      const { mains, bonus } = group;

      const itemBonus = findItem(bonus);

      const desiredBonusQty = mains.reduce((sum, main) => {
        const itemMain = findItem(main.id);
        const qtyMain = itemMain ? itemMain.quantity : 0;
        return sum + (qtyMain * main.factor);
      }, 0);

      if (desiredBonusQty > 0) {
        if (!itemBonus) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [{ id: bonus, quantity: desiredBonusQty, properties: { gift: true } }]
            })
          });
        } else if (itemBonus.quantity !== desiredBonusQty) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: itemBonus.key, quantity: desiredBonusQty })
          });
        }
      } else {
        if (itemBonus) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: itemBonus.key, quantity: 0 })
          });
        }
      }
    }
  } catch (err) {
    console.error(err);
  } finally {
    window._linkedBonusUpdating = false;
  }
}

async function manageGlobalGift() {

  // const isBlackFridayActive = localStorage.getItem("blackfriday_active") === "true";
  // if (!isBlackFridayActive) {
  //   return;
  // }

  const GIFT_VARIANT_ID = 51494965248319;
  const GIFT_QTY = 1;

  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    const hasProducts = cart.items.some(item => !item.properties?.gift);
    const giftItem = cart.items.find(i => Number(i.variant_id) === GIFT_VARIANT_ID);

    if (hasProducts) {
      if (!giftItem) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [
              {
                id: GIFT_VARIANT_ID,
                quantity: GIFT_QTY,
                properties: { gift: true }
              }
            ]
          })
        });
      } else if (giftItem.quantity !== GIFT_QTY) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: giftItem.key, quantity: GIFT_QTY })
        });
      }
    } else {
      if (giftItem) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 })
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}




function parseDate(dataPtBr) {
  const [d, m, a] = dataPtBr.split("/");
  return new Date(a, m - 1, d);
}


function runCartClearOnce() {
  const hasRun = localStorage.getItem('cartClearExecuted');

  if (!hasRun) {
    fetch('/cart/clear.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Erro ao limpar o carrinho');
      }
      return response.json();
    })
    .then(() => {
      updateMiniCartInFront();
      localStorage.setItem('cartClearExecuted', 'true');
    })
    .catch(error => {
      console.error('Erro durante a execução de clear cart:', error);
    });
  }
}